<div class="mm-insight-popup-header-data-progress" *ngIf="studyProgress !== undefined"
     [class.mm-insight-popup-header-data-progress-negative]="studyProgress.learningGoal !== undefined && studyProgress.studyProgress !== undefined && studyProgress.studyProgress < studyProgress.learningGoal">
    <div class="mm-insight-popup-header-data-learning-progress" title="{{ 'learningGoal.insightsPopup.learningProgress' | translate }}">
        <div
            class="mm-insight-popup-header-data-learning-progress-value">{{ studyProgress.studyProgress }}
        </div>
        <div class="mm-insight-popup-header-data-learning-progress-percentage">%</div>
    </div>
    <div class="mm-insight-popup-header-data-learning-goal"
         title="{{ 'learningGoal.learningGoal' | translate }}">
        <app-icon icon="flag-checkered-light-new"
                  class="mm-insight-popup-header-data-learning-goal-icon"></app-icon>
        <div class="mm-insight-popup-header-data-learning-goal-value"
             *ngIf="studyProgress.learningGoal !== undefined && studyProgress.learningGoal > 0">
            {{ studyProgress.learningGoal }} %
        </div>
        <div class="mm-insight-popup-header-data-learning-goal-value"
             *ngIf="studyProgress.learningGoal === undefined">
            –
        </div>
    </div>


    <div
        class="mm-insight-popup-header-data-learning-progress-indicator mm-insight-popup-header-data-learning-progress-indicator-forgetting"
        *ngIf="studyProgress.shouldShowAmountOfForgettingIndicator">
        <div class="mm-insight-popup-header-data-forgetting"
             title="{{ 'learningGoal.forgettingApplied' | translate }}">
            {{ (studyProgress.amountOfForgetting) }}<span
            class="mm-insight-popup-header-data-forgetting-percent">%</span>
        </div>

    </div>

    <div
        class="mm-insight-popup-header-data-learning-progress-indicator mm-insight-popup-header-data-learning-progress-indicator-learn"
        *ngIf="studyProgress.shouldShowLearnIndicator ">
        <app-icon icon="user-clock-solid" title="{{ 'learningGoal.forgettingApplied' | translate }}"
                  class="mm-insight-popup-header-data-learning-progress-indicator-learn-icon"></app-icon>
    </div>
</div>
